import StarBoldIcon from 'public/images/icons/star_bold.svg';

const Icons = {
  StarBoldIcon,
};

export default Icons;
